import { render, staticRenderFns } from "./RushRaceRating.vue?vue&type=template&id=01da0896&scoped=true&"
import script from "./RushRaceRating.vue?vue&type=script&lang=js&"
export * from "./RushRaceRating.vue?vue&type=script&lang=js&"
import style0 from "./RushRaceRating.vue?vue&type=style&index=0&id=01da0896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01da0896",
  null
  
)

export default component.exports